<template>
  <div>
    <div class="row" v-if="dashboards !== null">
      <div class="col-xl-2 col-lg-6 col-12 px--5">
        <CCard
          :bgColor="primaryColor"
          :textColor="'white'"
          :text="'All Bills Payment'"
          :value="dashboards.all_bills_payment"
          :valueColor="'white'"
          :cardImg="usersIcon"
          :currency="true"
        />
      </div>
      <div class="col-xl-2 col-lg-6 col-12 px--5">
        <CCard
          :bgColor="activeColor"
          :textColor="textColor"
          :text="'All Time Inter Bank Transfer'"
          :value="dashboards.all_time_inter_bank_transfer"
          :valueColor="valueColor"
          :cardImg="usersIcon"
          :currency="true"
        />
      </div>
      <div class="col-xl-2 col-lg-6 col-12 px--5">
        <CCard
          :bgColor="primaryColor"
          :textColor="'white'"
          :text="'All Time Intra Bank Transfer'"
          :value="dashboards.all_time_intra_bank_transfer"
          :valueColor="'white'"
          :cardImg="usersIcon"
          :currency="true"
        />
      </div>
      <div class="col-xl-2 col-lg-6 col-12 px--5">
        <CCard
          :bgColor="activeColor"
          :textColor="textColor"
          :text="'All Customers'"
          :value="dashboards.all_time_customers"
          :valueColor="valueColor"
          :cardImg="usersIcon"
        />
      </div>
      <div class="col-xl-2 col-lg-6 col-12 px--5">
        <CCard
          :bgColor="'#7987A1'"
          :text="'New Customer Today'"
          :value="dashboards.new_customer_today"
          :cardImg="discountIcon"
        />
      </div>
      <div class="col-xl-2 col-lg-6 col-12 px--5">
        <CCard
          :bgColor="activeColor"
          :text="'Active Terminals'"
          :value="dashboards.no_of_active_terminals"
          :cardImg="transactionIcon"
        />
      </div>
      <div class="col-xl-2 col-lg-6 col-12 px--5">
        <CCard
          :bgColor="'#FBC108'"
          :text="'Pending Transactions'"
          :value="dashboards.pending_transactions"
          :cardImg="transactionIcon"
        />
      </div>
      <div class="col-xl-2 col-lg-6 col-12 px--5">
        <CCard
          :bgColor="'#FB0800'"
          :text="'Failed Transactions'"
          :value="dashboards.failed_transactions"
          :cardImg="transactionIcon"
        />
      </div>
      <div class="col-xl-2 col-lg-6 col-12 px--5">
        <CCard
          :bgColor="'#2CB858'"
          :textColor="'#001833'"
          :text="'New Terminal Requests'"
          :value="dashboards.new_terminal_requests"
          :valueColor="valueColor"
          :cardImg="transactionIcon"
        />
      </div>
      <div class="col-xl-2 col-lg-6 col-12 px--5">
        <CCard
          :bgColor="'#FB0800'"
          :text="'Flagged Transactions'"
          :value="dashboards.flagged_transactions"
          :cardImg="transactionIcon"
        />
      </div>
      <div class="col-xl-2 col-lg-6 col-12 px--5">
        <CCard
          :bgColor="'#00FF00'"
          :text="'New Kiddies Today'"
          :value="dashboards.new_kiddies_today"
          :cardImg="discountIcon"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-12" v-if="tranStats">
        <div class="card card--no-shadow">
          <div class=" card-header bg-white">
            <h4>Transactions Stats</h4>
          </div>
          <div class=" card-body shadow-lg rounded-sm">
            <KeyValue
              objKey="All Successful Transactions Last Week"
              :objValue="tranStats.all_successful_transactions_last_week"
            />
            <KeyValue
              objKey="All Successful Transactions This Month"
              :objValue="tranStats.all_successful_transactions_this_month"
            />
            <KeyValue
              objKey="Failed Transactions Today"
              :objValue="tranStats.failed_transactions_today"
            />
            <KeyValue
              objKey="Pending Transactions Today"
              :objValue="tranStats.pending_transactions_today"
            />
            <KeyValue
              objKey="Successful Transactions Today"
              :objValue="tranStats.successful_transactions_today"
            />

            <KeyValue
              objKey="Terminal Successful Transactions Today"
              :objValue="tranStats.terminal_successful_transactions_today"
            />
            <KeyValue
              objKey="Transaction Attempts Today"
              :objValue="tranStats.transaction_attempts_today"
            />
            <KeyValue
              objKey="Total Inflow Today"
              :objValue="tranStats.inter_bank_inflow_today"
            />
          </div>
        </div>
      </div>
      
      <div class="col-md-4 col-12" v-if="customerStats">
        <div class="card card--no-shadow">
          <div class=" card-header bg-white">
            <h4>Customers Stats</h4>
          </div>
          <div class=" card-body shadow-lg rounded-sm">
            <KeyValue
              objKey="All Time Customer"
              :objValue="customerStats.all_time_customers"
            />
            <KeyValue
              objKey="Customers This Week"
              :objValue="customerStats.customer_this_week"
            />
            <KeyValue
              objKey="Customers Last Week"
              :objValue="customerStats.customer_last_week"
            />                        
            <KeyValue
              objKey="Customers Today"
              :objValue="customerStats.customer_today"
            />
            <KeyValue
              objKey="Customers Yesterday"
              :objValue="customerStats.customer_yesterday"
            />
            <KeyValue
              objKey="Customers 2 Days Ago"
              :objValue="customerStats.customer_2_days_ago"
            />
            <KeyValue
              objKey="Customers This Month"
              :objValue="customerStats.customer_this_month"
            />
            <KeyValue
              objKey="Customers Last Week"
              :objValue="customerStats.customer_last_week"
            />
            <KeyValue
              objKey="Customers Last Month"
              :objValue="customerStats.customer_last_month"
            />
            <KeyValue
              objKey="Customers 2 Month Ago"
              :objValue="customerStats.customer_2_months_ago"
            />
          </div>
        </div>
      </div>
     
      <div class="col-md-4 col-12" v-if="referralStats">
        <div class="card card--no-shadow">
          <div class=" card-header bg-white">
            <h4>Referrals Stats</h4>
          </div>
          <div class=" card-body shadow-lg rounded-sm">
            <KeyValue
              objKey="Customer by Referral Today"
              :objValue="referralStats.customer_by_referral_today"
            />
            <KeyValue
              objKey="Customer by Referral Yesterday"
              :objValue="referralStats.customer_by_referral_yesterday"
            />
            <KeyValue
              objKey="Customer by Referral This Week"
              :objValue="referralStats.customer_by_referral_this_week"
            />
            <KeyValue
              objKey="Customer by Referral Last Week"
              :objValue="referralStats.customer_by_referral_last_week"
            />
            <KeyValue
              objKey="Customer by Referral This Month"
              :objValue="referralStats.customer_by_referral_this_month"
            />

            <KeyValue
              objKey="Customer Not Reffered Today"
              :objValue="referralStats.customer_not_referred_today"
            />

            <KeyValue
              objKey="Customer Not Reffered Yesterday"
              :objValue="referralStats.customer_not_referred_yesterday"
            />

            <KeyValue
              objKey="Customer Not Reffered This Week"
              :objValue="referralStats.customer_not_referred_this_week"
            />

            <KeyValue
              objKey="Customer Not Reffered Last Week"
              :objValue="referralStats.customer_not_referred_last_week"
            />

            <KeyValue
              objKey="Customer Not Reffered This Month"
              :objValue="referralStats.customer_not_referred_this_month"
            />

          </div>
        </div>
      </div>

      <div class="col-md-4 col-12" v-if="kiddiesStats">
        <div class="card card--no-shadow">
          <div class=" card-header bg-white">
            <h4>Kiddies Stats</h4>
          </div>
          <div class=" card-body shadow-lg rounded-sm">
            <KeyValue
              objKey="Pending Requests Today"
              :objValue="kiddiesStats.pending_requests_today"
            />
            <KeyValue
              objKey="Pending Requests Yesterday"
              :objValue="kiddiesStats.pending_requests_yesterday"
            />
            <KeyValue
              objKey="Pending Requests This Week"
              :objValue="kiddiesStats.pending_requests_this_week"
            />
            <KeyValue
              objKey="Approved Requests Last Week"
              :objValue="kiddiesStats.approved_requests_last_week"
            />
            <KeyValue
              objKey="Pending Requests This Month"
              :objValue="kiddiesStats.pending_requests_this_month"
            />
            <KeyValue
              objKey="Approved Requests Last Month"
              :objValue="kiddiesStats.approved_requests_last_month"
            />
            <KeyValue
              objKey="Pending Requests Two Months Ago"
              :objValue="kiddiesStats.pending_requests_two_months_ago"
            />
            <KeyValue
              objKey="Approved Requests Two Months Ago"
              :objValue="kiddiesStats.approved_requests_two_months_ago"
            />
            <KeyValue
              objKey="All Time Pending Requests"
              :objValue="kiddiesStats.all_time_pending_requests"
            />
            <KeyValue
              objKey="All Time Approved Requests"
              :objValue="kiddiesStats.all_time_approved_requests"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="card card--no-shadow">
      <div class="card-content">
        <div class="card-body">
          <CDataTable
            :items="topFive"
            :fields="fields"
            :items-per-page="10"
            pagination
            sorter
            tableFilter
          >
            <template #balance="{item}">
              <td>{{ item.terminal.terminal_balance }}</td>
            </template>
            <template #terminalID="{item}">
              <td>{{ item.terminal.terminalID }}</td>
            </template>
            <template #terminal_status="{item}">
              <td>{{ item.terminal.terminal_status }}</td>
            </template>
            <template #name="{item}">
              <td>
                {{
                  item.terminal.user.first_name +
                    " " +
                    item.terminal.user.last_name
                }}
              </td>
            </template>
            <template #updated_at="{item}">
              <td class="table--action-mobile">
                {{ item.updated_at | date }}
              </td>
            </template>
            <template #action="{item}">
              <td
                class="table--action-mobile"
                v-if="permissions.includes('view-terminal')"
              >
                <router-link
                  class="button btn-primary"
                  :to="{
                    name: 'ViewTerminal',
                    params: { slug: item.terminal.terminalID }
                  }"
                >
                  View
                </router-link>
              </td>
            </template>
          </CDataTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CDataTable from "@/components/CDataTable.vue";
import CCard from "@/components/CCard";
import ApiService from "@/services/api.service";
import { mapGetters, mapActions } from "vuex";
import usersIcon from "@/assets/images/users-avatar.png";
import discountIcon from "@/assets/images/discount-icon.png";
import transactionIcon from "@/assets/images/transaction-icon.png";
import KeyValue from "@/components/KeyValue.vue";
const fields = [
  "terminalID",
  "name",
  "balance",
  "total_amount",
  "terminal_status",
  "action"
];
export default {
  name: "DashboardStat",
  components: {
    CCard,
    KeyValue,
    CDataTable
  },
  data() {
    return {
      fields,
      activeColor: "#2CB858",
      dangerColor: "#FBC108",
      primaryColor: "#242452",
      textColor: "#001833",
      valueColor: "#001833",
      // typeMonth: "column2d",
      // type: "pie2d",
      // renderAt: "chart-container",
      // width: "100%",
      // height: "350",
      // dataFormat: "json",
      // dataSource,
      monthDataSource: {},
      monthData: [],
      dashboards: null,
      usersIcon,
      discountIcon,
      transactionIcon,
      balances: {},
      topFive: [],
      customerStats: null,
      tranStats: null,
      referralStats : null,
      kiddiesStats: null
    };
  },
  computed: {
    ...mapGetters(["loggedIn"]),
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    }
  },
  methods: {
    async dashboardCustomers() {
      try {
        const res = await ApiService.get("stats/dashboard_customers");
        // console.log(res);
        this.customerStats = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async dashboardTrans() {
      try {
        const res = await ApiService.get("stats/dashbboard_transactions");
        // console.log(res);
        this.tranStats = res.data.data;
      } catch (error) {
        // console.log(error);
      }
    },
    async getDashboardStats() {
      try {
        const response = await ApiService.get(`stats/dashboard`);
        this.dashboards = response.data.data;
        // console.log(this.dashboards);
      } catch (error) {
        // console.log(error.response);
      }
    },
    async getDashboardReferralStats() {
      try {
        const response = await ApiService.get(`stats/referral_dashboard`);
        this.referralStats = response.data.data;
        // console.log(this.dashboards);.
      } catch (error) {
        // console.log(error.response);
      }
    },
    async getBalances() {
      try {
        const response = await ApiService.get(`settings/balance`);
        this.balances = response.data.data;
        // console.log(this.balances);
      } catch (error) {
        // console.log(error.response);
      }
    },
    async top5Terminal() {
      try {
        const response = await ApiService.get("terminal/top-5-terminals/all");
        this.topFive = response.data.data;
      } catch (error) {
        // console.log(error.response);
      }
    },
    async getKiddiesStats() {
      try {
        const response = await ApiService.get("stats/kiddie_account_stats");
        this.kiddiesStats = response.data.data;
      } catch (error) {
        // console.log(error.response);
      }
    }
  },
  mounted() {
    this.dashboardCustomers();
    this.dashboardTrans();
    // console.log(this.loggedIn);
    this.getDashboardStats();
    this.getDashboardReferralStats();
    // this.getBalances();
    this.top5Terminal();
    this.getKiddiesStats();
    // setTimeout(() => {
    //   this.monthData = [
    //     {
    //       label: "January",
    //       value: "290"
    //     },
    //     {
    //       label: "Feburary",
    //       value: "260"
    //     },
    //     {
    //       label: "March",
    //       value: "180"
    //     },
    //     {
    //       label: "April",
    //       value: "140"
    //     },
    //     {
    //       label: "May",
    //       value: "115"
    //     },
    //     {
    //       label: "June",
    //       value: "100"
    //     },
    //     {
    //       label: "July",
    //       value: "30"
    //     },
    //     {
    //       label: "August",
    //       value: "30"
    //     },
    //     {
    //       label: "September",
    //       value: "49"
    //     },
    //     {
    //       label: "October",
    //       value: "180"
    //     },
    //     {
    //       label: "November",
    //       value: "140"
    //     },
    //     {
    //       label: "December",
    //       value: "115"
    //     }
    //   ];
    //   this.monthDataSource = {
    //     chart: {
    //       caption: "Loan Overview by Month",
    //       // subcaption: "In MMbbl = One Million barrels",
    //       xaxisname: "Month",
    //       yaxisname: "Loans",
    //       numbersuffix: "K",
    //       theme: "fusion"
    //     },
    //     data: this.monthData
    //   };
    // }, 200);
  }
};
</script>

<style scoped></style>
